<template>
    <div class="text-content">
        
    </div>
</template>

<script>
export default {};
</script>

<style></style>
